import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { Nullable } from "types/global";

export interface DefaultLanguageDataState {
  code: string;
  name: string;
}

export type Translation = {
  adminDefault: boolean;
  apiDefault: boolean;
  code: string;
  name: string;
  order: Nullable<number>;
};

type InitialState = {
  defaultLanguageData: DefaultLanguageDataState;
  availableTranslations: Translation[];
};

const initialState: InitialState = {
  defaultLanguageData: {
    code: "",
    name: "",
  },
  availableTranslations: [],
};

export const translationsSlice = createSlice({
  name: "translations",
  initialState,
  reducers: {
    setTranslations: (
      state,
      action: PayloadAction<{ translations: Translation[] }>,
    ) => {
      const { translations } = action.payload;
      const defaultLanguage = translations?.find(
        (lang) => lang.apiDefault,
      ) as Translation;

      state.defaultLanguageData = {
        code: defaultLanguage?.code,
        name: defaultLanguage?.name,
      };

      state.availableTranslations = translations;
    },
  },
});

export const { setTranslations } = translationsSlice.actions;

export const selectDefaultLanguageData = (state: RootState) =>
  state.translations.defaultLanguageData;

export const selectAvaiableTranslations = (state: RootState) =>
  state.translations.availableTranslations;

export default translationsSlice.reducer;
